var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarContainer } from './sidebar-container.component';
import { Sidebar } from './sidebar.component';
import { CloseSidebar } from './close.directive';
var SidebarModule = (function () {
    function SidebarModule() {
    }
    SidebarModule_1 = SidebarModule;
    SidebarModule.forRoot = function () {
        return {
            ngModule: SidebarModule_1
        };
    };
    var SidebarModule_1;
    SidebarModule = SidebarModule_1 = __decorate([
        NgModule({
            declarations: [SidebarContainer, Sidebar, CloseSidebar],
            imports: [CommonModule],
            exports: [SidebarContainer, Sidebar, CloseSidebar]
        })
    ], SidebarModule);
    return SidebarModule;
}());
export { SidebarModule };
